// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@sc/Overrides/Components/CartTotalDisplay";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    ...orderTotalDisplaySharedStyles.mainContainer,
};

cartTotalDisplayStyles.fullWidthGridItem = {
    width: 12,
    css: css`
        padding: 5px 0;
    `,
};

cartTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};
cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};
cartTotalDisplayStyles.otherChargesLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};

cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
    ...(TRANSLATE_OBJECT as any),
};

cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
    ...(TRANSLATE_OBJECT as any),
};

cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.totalWrapper = {
    css: css`
        width: 100%;
        display: flex;
        padding-top: 12px;
        border-top: 1px solid ${color("common.border")};
    `,
};
cartTotalDisplayStyles.microCopyText = {
    size: 12,
    lineHeight: "13px",
    css: css`
        margin-bottom: 4px;
        display: flex;
        align-items: baseline;
        &:before {
            content: "*";
            color: ${color("danger")};
            margin-right: 4px;
        }
    `,
};

cartTotalDisplayStyles.DiscountsLabelGridItem = {
    width: 5,
    css: css``,
};
cartTotalDisplayStyles.DiscountsValueGridItem = {
    width: 7,
    css: css`
        @media print {
            text-align: right;
        }
    `,
};
